import React from 'react';
import {connect} from "react-redux";
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class RaceControl extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            week: (moment(new Date()).isoWeekday() > 3 ?  moment(new Date()).isoWeek() : moment(new Date()).isoWeek() - 1).toString(),
            fromSection: '',
            toSection: '',
            fromClub: '',
            toClub: '',
            report: this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? 'equipControl' : 'manReg',
            manRegKfk: '',
            manRegType: 'result',
        });
    }

    fields = [];
    render() {
        return <div className="season-equip-stats reports-inner-box report-options">
            <table style={{maxWidth: '500px'}}>
                <tbody>
                    <tr>
                        <td><label htmlFor="fromWeek">Uge</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="week" id="week" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,2}"}]} value={this.state.week}
                                              autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[0] = instance; }}
                        /></td>
                    </tr>
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                        <td><label htmlFor="fromSection">Fra sektion</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="fromSection" id="fromSection" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.fromSection}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[1] = instance; }}
                        /></td>
                        <td><label htmlFor="toSection">Til sektion</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="toSection" id="toSection" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.toSection}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[2] = instance; }}
                        /></td>
                    </tr> : null}
                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <tr>
                        <td><label htmlFor="fromClub">Fra forening</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="fromClub" id="fromClub" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.fromClub}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              onBlur={() => {
                                                  this.fields[3].setState({focused: false, visited: true});
                                                  if (/^[0-9]{1,2}$/.test(this.state.fromClub)) this.setState({fromClub: this.state.fromClub.padStart(3, '0')});
                                              }}
                                              ref={instance => { this.fields[3] = instance; }}
                        /></td>
                        <td><label htmlFor="toClub">Til forening</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="toClub" id="toClub" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.toClub}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              onBlur={() => {
                                                  this.fields[4].setState({focused: false, visited: true});
                                                  if (/^[0-9]{1,2}$/.test(this.state.toClub)) this.setState({toClub: this.state.toClub.padStart(3, '0')});
                                              }}
                                              ref={instance => { this.fields[4] = instance; }}
                        /></td>
                    </tr>}
                    <tr className="options-separator"/>
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                        <td colSpan={2}>
                            <input id="reportEquipControl" name="report" type="radio" checked={this.state.report === 'equipControl'} onClick={e => this.setState({report: 'equipControl'})}/> <label htmlFor="reportEquipControl">Kontrolliste for anlæg</label>
                        </td>
                    </tr> : null}
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                        <td colSpan={2}>
                            <input id="reportForfald" name="report" type="radio" checked={this.state.report === 'forfald'} onClick={e => this.setState({report: 'forfald'})}/> <label htmlFor="reportForfald">Forfaldsliste</label>
                        </td>
                    </tr> : null}
                    <tr>
                        <td colSpan={2}>
                            <input id="reportManReg" name="report" type="radio" checked={this.state.report === 'manReg'} onClick={e => this.setState({report: 'manReg'})}/> <label htmlFor="reportManReg">Manuel registrering</label>
                        </td>
                    </tr>
                    <tr className="options-separator"/>
                    {this.state.report === 'manReg' ? [
                        <tr>
                            <td><label htmlFor="kfk">KFK</label></td>
                            <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                                  name="manRegKfk" id="manRegKfk" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.manRegKfk}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  onBlur={() => {
                                                      this.fields[5].setState({focused: false, visited: true});
                                                      if (/^[0-9]{1}$/.test(this.state.manRegKfk)) this.setState({manRegKfk: this.state.manRegKfk.padStart(2, '9')});
                                                  }}
                                                  ref={instance => { this.fields[5] = instance; }}
                            /></td>
                        </tr>,
                        <tr className="options-separator"/>,
                        <tr>
                            <td colSpan={2}>
                                <input id="manRegTypeSignup" name="manRegType" type="radio" checked={this.state.manRegType === 'signup'} onClick={e => this.setState({manRegType: 'signup'})}/> <label htmlFor="manRegTypeSignup">Regnskab</label>
                            </td>
                            <td colSpan={2}>
                                <input id="manRegTypeResult" name="manRegType" type="radio" checked={this.state.manRegType === 'result'} onClick={e => this.setState({manRegType: 'result'})}/> <label htmlFor="manRegTypeResult">Resultat</label>
                            </td>
                        </tr>
                    ] : null}
                </tbody>
            </table>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }

        const options = {
            report: this.state.report,
            week: this.state.week === '' ? null : Number(this.state.week),
            fromSection: this.state.fromSection === '' ? null : this.state.fromSection,
            toSection: this.state.toSection === '' ? null : this.state.toSection,
            fromClub: this.state.fromClub === '' ? null : this.state.fromClub,
            toClub: this.state.toClub === '' ? null : this.state.toClub,
            showClubs: this.state.showClubs,
        };
        if (this.state.report === 'manReg') {
            options.manRegKfk = this.state.manRegKfk === '' ? null : this.state.manRegKfk;
            options.manRegType = this.state.manRegType;
        }

        return {
            errors: errors,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(RaceControl);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/RaceControl.js